import styled from "styled-components";

export const FooterStyle = styled.footer`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  background-color: var(--white);
  border-radius: 0.3rem;
  padding: 0px 1rem 0px 1rem;
  > div {
    > span {
    }
    > a {
      color: black;
    }
  }
`;
